// extracted by mini-css-extract-plugin
export default {"title":"PageContainer_title__MsoV9"};